const formatCurrencyRange = ({
  min,
  max,
}: {
  min: number | null | undefined;
  max: number | null | undefined;
}) => {
  if (!isNumber(min) && !isNumber(max)) return "";

  if (isNumber(min) && !isNumber(max)) return `Min ${min / 100000} lpa`;
  else if (!isNumber(min) && isNumber(max)) return `Max ${max / 100000} lpa`;
  else return `${min / 100000}-${max / 100000} lpa`;
};

export default formatCurrencyRange;

const isNumber = (value: number | null | undefined) =>
  typeof value === "number";
